module.exports = __webpack_public_path__ + "static/media/susu.210e2eee.png";